import * as Yup from 'yup';
import React, { useContext, useEffect, useState } from 'react';
import { Row, Col, Modal as BootstrapModal } from 'react-bootstrap';
import { useFormik } from 'formik';
import { useQuery } from '@apollo/react-hooks';
import { Button, Form, FormInput } from 'modules';
import { AgreementByContractQuery } from 'queries/Agreement/AgreementData';
import Agreement from './Agreement';
import { notifySuccess } from 'helpers/notify';
import { WebsocketActions, WebsocketContext } from 'services/WebsocketContext';
import { TARIFFS } from 'constants/Tariffs';
import DruhPrijmuSelect from 'components/DruhPrijmuSelect';
import { v4 as uuidv4 } from 'uuid';

const myUUID = uuidv4();

interface FormModalProps {
  isViewMode: boolean;
  client2Id: string;
  form: GQL.IContractOnlineForm;
  contract: GQL.IContract;
  values: GQL.ITClient2 | null;
  onChange: (e: React.ChangeEvent) => void;
  onClose: () => void;
}

const FormModal = ({ isViewMode, client2Id, form, contract, values, onClose, ...props }: FormModalProps) => {
  const wsContext = useContext(WebsocketContext);

  // TODO: toto tu musí být?
  // TODO: mám přeci informaci z agreementQuery
  const [agreement, setAgreement] = useState({
    data: null,
    loading: false,
    checked: false,
  });

  // souhlas partnera smlouvy
  const agreementQuery = useQuery(AgreementByContractQuery, {
    variables: {
      where: {
        contractId: contract.id,
        clientId: contract.id_klient_2,
      },
    },
  });

  const handleClose = (e: React.MouseEvent) => {
    onClose();
    e.stopPropagation();
    e.preventDefault();
  };

  const validation = Yup.object().shape({
    lastName: Yup.string().required('Příjmení je povinné!'),
    firstName: Yup.string().required('Jméno je povinné!'),
    cislo_op: Yup.string().required('Číslo OP je povinné!'),
    rodne_cislo: Yup.string().required('Rodné číslo je povinné!'),
    // adresa
    street: Yup.string().nullable().required('Ulica je povinná!'),
    houseNumber: Yup.string().nullable().required('Súpisné číslo je povinné!'),
    city: Yup.string().nullable().required('Miesto je povinné!'),
    zipCode: Yup.string().nullable().required('PSČ je povinné!'),
    // income
    income: Yup.string().nullable().required('Druh príjmu je povinný!'),
    // souhlas
    agreement: Yup.string().nullable().required('Súhlas je povinný!'),
  });

  const formik = useFormik<GQL.ITClient2>({
    initialValues: {
      lastName: values?.lastName,
      firstName: values?.firstName,
      mobil: values?.mobil,
      email: values?.email,
      cislo_op: values?.cislo_op,
      rodne_cislo: values?.rodne_cislo,
      // adresa
      street: values?.street,
      houseNumber: values?.houseNumber,
      city: values?.city,
      zipCode: values?.zipCode,
      // koresp. adresa
      mailingAddress: values?.mailingAddress || false,
      mailingAddressStreet: values?.mailingAddressStreet,
      mailingAddressHouseNumber: values?.mailingAddressHouseNumber,
      mailingAddressCity: values?.mailingAddressCity,
      mailingAddressZipCode: values?.mailingAddressZipCode,
      // income
      income: values?.income,
      incomeValue: values?.incomeValue,
      // souhlas
      agreement: values?.agreement || false,
      // dokončeno zadávání partnera v modalu
      finished: false,
    } as any,
    validationSchema: validation,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: () => {
      if (formik.isValid) {
        // dokončení zadání partnera
        wsContext?.send({
          action: WebsocketActions.CONTRACT_PARTNER_CHANGE,
          value: {
            name: 'finished',
            value: true,
          },
        });
        // změna tarifu
        wsContext?.send({
          action: WebsocketActions.CONTRACT_DATA_CHANGE,
          value: {
            name: 'productId',
            value: TARIFFS.OBO_MA_2023,
          },
        });
        // notifikace
        notifySuccess('Manžel / manželka bol pridaný k zmluve');
      }
    },
  });

  // TODO: setAgreement by bylo vhodné odstranit
  // TODO: v komponentě níže state okolo agreementu předělat
  // data o souhlasu z BE
  useEffect(() => {
    setAgreement({
      data: agreementQuery.data?.agreementByContract,
      checked: !!agreementQuery.data?.agreementByContract,
      loading: agreementQuery.loading,
    });
  }, [agreementQuery]);

  // změna v souhlasu, provedl klient
  const onChangeAgreement = (e: React.ChangeEvent) => {
    const { value } = e.target as HTMLInputElement;
    // změna dat partnera
    wsContext?.send({
      action: WebsocketActions.CONTRACT_PARTNER_CHANGE,
      value: {
        name: 'agreement',
        value,
      },
    });
  };

  const handleChange = (e: React.ChangeEvent) => {
    const { name, value } = e.target as HTMLInputElement;
    formik.handleChange(e);
    wsContext?.send({
      action: WebsocketActions.CONTRACT_PARTNER_CHANGE,
      value: {
        sender: myUUID,
        name,
        value,
      },
    });
  };

  // TODO: ověřit, že toto je používáno
  const handleSubmitAgreement = () => {
    // změna dat partnera
    wsContext?.send({
      action: WebsocketActions.CONTRACT_PARTNER_CHANGE,
      value: {
        name: 'refetchAgreement',
      },
    });
  };

  // TODO: proč se data z formuláře neodesílají rovnou v OnlineFormData.tsx?
  // strana oblastního
  // ve formuláři se změnili data, odešlou se na BE
  useEffect(() => {
    // posílám data partnera o úroveň výš
    // TODO: fuj!
    props.onChange({
      target: {
        name: 'client2',
        value: formik.values,
      },
    } as any);
    // modal dokončen
    if (formik.values.finished === true) {
      onClose();
    }
    // eslint-disable-next-line
  }, [formik.values]);

  const isValid = () => {
    // TODO: state agreement odstranit!
    return !!agreement.data || agreement.checked;
  };

  useEffect(() => {
    wsContext?.ws?.on(WebsocketActions.CONTRACT_PARTNER_CHANGE, (data) => {
      // změna dat partnera
      if (data.sender !== myUUID) {
        if (data.name in formik.values && (formik.values as any)[data.name] !== data.value) {
          formik.setFieldValue(data.name, data.value);
        }
      }
      if (data.name === 'refetchAgreement') {
        agreementQuery.refetch();
      }
    });
    return () => {
      wsContext?.ws?.off(WebsocketActions.CONTRACT_PARTNER_CHANGE);
    };
    // eslint-disable-next-line
  }, [wsContext]);

  return (
    <BootstrapModal
      show
      onHide={onClose}
      backdrop="static"
      keyboard={false}
      animation={false}
      dialogClassName="modal-80w max-w-800"
    >
      <Form onSubmit={formik.handleSubmit}>
        <BootstrapModal.Header closeButton>
          <BootstrapModal.Title>Manžel / Manželka</BootstrapModal.Title>
        </BootstrapModal.Header>
        <BootstrapModal.Body>
          <Row>
            <Col sm={6}>
              <FormInput
                name="lastName"
                label="Příjmení"
                required
                readOnly={isViewMode}
                value={formik.values.lastName}
                error={formik.errors.lastName}
                onChange={handleChange}
              />
            </Col>
            <Col sm={6}>
              <FormInput
                name="firstName"
                label="Jméno"
                required
                readOnly={isViewMode}
                value={formik.values.firstName}
                error={formik.errors.firstName}
                onChange={handleChange}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={3}>
              <FormInput
                name="mobil"
                label="Mobil"
                required
                readOnly={isViewMode}
                value={formik.values.mobil}
                error={formik.errors.mobil}
                onChange={handleChange}
              />
            </Col>
            <Col sm={3}>
              <FormInput
                name="email"
                label="E-mail"
                required
                readOnly={isViewMode}
                value={formik.values.email}
                error={formik.errors.email}
                onChange={handleChange}
              />
            </Col>
            <Col sm={3}>
              <FormInput
                name="cislo_op"
                label="Číslo OP"
                required
                readOnly={isViewMode}
                value={formik.values.cislo_op}
                error={formik.errors.cislo_op}
                onChange={handleChange}
              />
            </Col>
            <Col sm={3}>
              <FormInput
                name="rodne_cislo"
                label="Rodné číslo"
                required
                readOnly={isViewMode}
                value={formik.values.rodne_cislo}
                error={formik.errors.rodne_cislo}
                onChange={handleChange}
              />
            </Col>
          </Row>

          <Row>
            <Col md={4} xs={8}>
              <FormInput
                name="street"
                label={'Ulica'}
                required
                readOnly={isViewMode}
                value={formik.values.street}
                error={formik.errors.street}
                onChange={handleChange}
              />
            </Col>
            <Col md={2} xs={4}>
              <FormInput
                name="houseNumber"
                label={'Súpisné č.'}
                required
                readOnly={isViewMode}
                value={formik.values.houseNumber}
                error={formik.errors.houseNumber}
                onChange={handleChange}
              />
            </Col>
            <Col md={4} xs={8}>
              <FormInput
                name="city"
                label={'Mesto'}
                required
                readOnly={isViewMode}
                value={formik.values.city}
                error={formik.errors.city}
                onChange={handleChange}
              />
            </Col>
            <Col md={2} xs={4}>
              <FormInput
                name="zipCode"
                label={'PSČ'}
                required
                readOnly={isViewMode}
                value={formik.values.zipCode}
                error={formik.errors.zipCode}
                onChange={handleChange}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <FormInput
                type="checkbox"
                name="mailingAddress"
                label={'Korešpondenčná adresa'}
                readOnly={isViewMode}
                checked={!!formik.values.mailingAddress}
                error={formik.errors.mailingAddress}
                onChange={handleChange}
              />
            </Col>
          </Row>

          {formik.values.mailingAddress === true && (
            <Row>
              <Col md={4} xs={8}>
                <FormInput
                  name="mailingAddressStreet"
                  label={'Koresp. ulica'}
                  readOnly={isViewMode}
                  value={formik.values.mailingAddressStreet}
                  error={formik.errors.mailingAddressStreet}
                  onChange={handleChange}
                />
              </Col>
              <Col md={2} xs={4}>
                <FormInput
                  name="mailingAddressHouseNumber"
                  label={'Koresp. súpisné č.'}
                  readOnly={isViewMode}
                  value={formik.values.mailingAddressHouseNumber}
                  error={formik.errors.mailingAddressHouseNumber}
                  onChange={handleChange}
                />
              </Col>
              <Col md={4} xs={8}>
                <FormInput
                  name="mailingAddressCity"
                  label={'Koresp. mesto'}
                  readOnly={isViewMode}
                  value={formik.values.mailingAddressCity}
                  error={formik.errors.mailingAddressCity}
                  onChange={handleChange}
                />
              </Col>
              <Col md={2} xs={4}>
                <FormInput
                  name="mailingAddressZipCode"
                  label={'Koresp. PSČ'}
                  readOnly={isViewMode}
                  value={formik.values.mailingAddressZipCode}
                  error={formik.errors.mailingAddressZipCode}
                  onChange={handleChange}
                />
              </Col>
            </Row>
          )}

          <Row>
            <Col sm={5}>
              <DruhPrijmuSelect
                name="income"
                label={'Príjem'}
                required={true}
                disabled={isViewMode}
                value={formik.values?.income}
                error={formik.errors?.income}
                onChange={handleChange}
              />
            </Col>
            <Col sm={3}>
              <FormInput
                type="number"
                name="incomeValue"
                label={'Výška príjmu'}
                min={0}
                disabled={isViewMode}
                value={formik.values?.incomeValue}
                error={formik.errors?.incomeValue}
                onChange={handleChange}
              />
            </Col>
          </Row>

          <hr />
          <Agreement
            isViewMode={isViewMode}
            contract={contract}
            form={form}
            loading={agreement.loading}
            data={agreement.data}
            values={formik.values}
            errors={formik.errors}
            onChange={(e) => {
              onChangeAgreement(e);
              formik.handleChange(e);
            }}
            // TODO: toto zprovoznit, aby se mohlo zaškrtnutí od klienta, dostat k oblastnímu
            // TODO: oblastní to zatím nevidí, ale může to tak být
            onSubmit={handleSubmitAgreement}
          />
        </BootstrapModal.Body>
        <BootstrapModal.Footer>
          <Button variant="secondary" disabled={isViewMode} onClick={handleClose}>
            Zavrieť
          </Button>
          <Button variant="primary" type="submit" disabled={isViewMode || !isValid()}>
            Uložiť
          </Button>
        </BootstrapModal.Footer>
      </Form>
    </BootstrapModal>
  );
};

export default FormModal;
